import React, { useState, useEffect, useCallback, useContext } from "react";
import { Menu, Icon, Dropdown, Popup, Grid, Header, Segment, Button as SemanticButton } from "semantic-ui-react";
import { OnHoverOnClick, Notifications, Button, SelectionsModal, DYLAvatar, SearchableOptions, ClippedContent, EmptyListPlaceholder, VALIDATION_PATTERNS, multipleRestriction, PRODUCT_PERMISSIONS, USER_PERMISSIONS, SETTINGS_PERMISSION_MAP, RestrictView, Notification, STATUS_TYPES } from "dyl-components";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';

import authActions from "actions/auth/auth";
import userActions from 'actions/user';
import appActions from 'actions/app/app';
import notificationsActions from "actions/notifications";

import MasterAccountForm from 'shared/MasterAccountForm';
import AddContactModal from 'shared/modals/AddContactModal';
import AddLeadModal from "shared/modals/AddLeadModal";
import AddOpportunityModal from "shared/modals/AddOpportunityModal";
import AddAccountModal from "shared/modals/AddAccountModal";
import SendEmailModal from "shared/modals/SendEmailModal";
import AddTaskModal from "shared/modals/AddTaskModal";
import AddEventModal from "shared/modals/AddEventModal";
import NotificationPopupModals from "shared/modals/NotificationPopUpModals";
import { withRouter } from 'shared/withRouter';

import { PhoneUtil, TZDisplay } from "utils";
import "./index.scss";
import FullScreenModalPopUp from "shared/FullScreenModalPopUp";
import basePath from "actions/basePath";
import contactActions from 'actions/contact';
import PHONE_ICON from "shared/constants/PHONE_ICON";
import textActions from "actions/text";
import leftSidebar from 'actions/left_sidebar_ui';
import RestrictedView from "shared/RestrictedView";
import { Error403 } from "pages/ErrorPages";
import { MainSidePanelContext } from "shared/context/MainSidePanelProvider";

import role from "actions/role";
import subscription from "actions/subscription";
import usersActions from "actions/users";
import contactsActions from 'actions/contacts';

const modalCategories = [
    {
        header: 'Modules',
        selections: [
            { key: 'Contact', text: 'Contact', icon: 'fa-solid fa-address-book', userPermission: USER_PERMISSIONS.CONTACTS_ADD, productPermission: PRODUCT_PERMISSIONS.RECORDS },
            { key: 'Lead', text: 'Lead', icon: 'user', userPermission: USER_PERMISSIONS.LEAD_ADD, productPermission: '' },
            { key: 'Opportunity', text: 'Opportunity', icon: 'fas fa-funnel-dollar', userPermission: USER_PERMISSIONS.OPPORTUNITY_ADD, productPermission: '' }
        ]
    },
    {
        header: 'Records',
        selections: [
            { key: 'MasterAccount', text: 'Master Account', icon: 'fa-solid fa-buildings', userPermission: USER_PERMISSIONS.MASTER_ACCOUNT_ADD, productPermission: '' },
            { key: 'BusinessAccount', text: 'Business Account', icon: 'fa-solid fa-building', userPermission: USER_PERMISSIONS.ACCOUNT_ADD, productPermission: PRODUCT_PERMISSIONS.RECORDS },
            { key: 'HouseholdAccount', text: 'Household Account', icon: 'fa-solid fa-house-chimney-blank', userPermission: USER_PERMISSIONS.ACCOUNT_ADD, productPermission: PRODUCT_PERMISSIONS.RECORDS }
        ]
    }
];
const ACCOUNT_ICONS = {
    household: "fa-solid fa-house-chimney",
    business: "fa-solid fa-building",
    master_account : "fa-solid fa-buildings"
}

//TODO: move onOpen to the AddContactModal and AddBusinessModal
const AddModuleRecordsModalContent = ({ activeContent, onClose, onDirtyChange }) => {
    const isAddingModule = useSelector(state => state.contacts.isCreating || state.pipeline.isConvertingContact || state.account.isLinkingContactsToAccount || state.contact_sequence.isHandlingConvert || state.sequences.isAddingContactToSequence || state.sequence_tasks.isReadingSequenceContactTasks)
    switch (activeContent) {
        case 'MasterAccount':
            return <MasterAccountForm close={onClose} onDirtyChange={onDirtyChange} />;
        case 'Contact':
            return <AddContactModal onOpen={() => { return Promise.resolve(); }} onClose={onClose} onDirtyChange={onDirtyChange}/>;
        case 'BusinessAccount':
            return <AddAccountModal account_type={'business'} onClose={onClose} onDirtyChange={onDirtyChange}/>;
        case 'HouseholdAccount':
            return <AddAccountModal account_type={'household'} onClose={onClose} onDirtyChange={onDirtyChange} />;
        case 'Lead':
            return <AddLeadModal onClose={() => {
                if (!isAddingModule) {
                    onClose();
                }
            }} onDirtyChange={onDirtyChange} />;
        case 'Opportunity':
            return <AddOpportunityModal onClose={() => {
                if (!isAddingModule) {
                    onClose();
                }
            }} onDirtyChange={onDirtyChange}/>;
        default:
            return null;
    }
}

const UniversalSearchResults = ({ loading, onSelectContact, index, universal_search_options }) => (
    <div className='UniversalSearch__container' key={index}>
            <Segment>
                {universal_search_options?.length > 0 ? (
                    <Grid>
                        {universal_search_options.map((element, idx) => {
                             const { name, id, account, email, phone, contact_type } = element;

                            return (
                                <Grid.Row
                                    verticalAlign='middle'
                                    className='UniversalSearch_rowContainer'
                                    key={idx}
                                    columns='equal'
                                    stretched
                                    onClick={() => onSelectContact(id, contact_type)}
                                >
                                    <Grid.Column width={4} >
                                        <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                                            <Icon className={`fa-solid ${contact_type ==="person" ? "fa-user" : contact_type === "household" ? "fa-house-chimney" : "fa-building"} UniversalSearch__userIcon`} size={"large"} />
                                            <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '145px' }}>
                                                <ClippedContent>
                                                    <strong>{name || account?.account_name}</strong>
                                                </ClippedContent>
                                                <ClippedContent>
                                                    <span className='UniversalSearch__email'>
                                                        ID: {id}
                                                    </span>
                                                </ClippedContent>
                                            </div>
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column width={4}>
                                        {phone && (
                                            <div style={{ display: 'flex', alignItems: 'center', maxWidth: '145px' }}>
                                                <Icon name={PHONE_ICON["Other"]} className="UniversalSearch__userIcon" size={"large"} />
                                                <ClippedContent>
                                                    <span>
                                                        {PhoneUtil.formatPhoneNumber(phone)}
                                                    </span>
                                                </ClippedContent>
                                            </div>
                                        )}
                                    </Grid.Column>
                                    <Grid.Column width={4}>
                                        {email && (
                                            <div style={{ display: 'flex', alignItems: 'center', maxWidth: '145px' }}>
                                                <Icon name={"fas fa-envelope"} className="UniversalSearch__userIcon" size={"large"} />
                                                <ClippedContent>
                                                    <span>
                                                        {email}
                                                    </span>
                                                </ClippedContent>
                                            </div>
                                        )}
                                    </Grid.Column>
                                    <Grid.Column width={4}>
                                        {id && account && (
                                            <div style={{ display: 'flex', alignItems: 'center', maxWidth: '145px' }}>
                                                <Icon className={`${ACCOUNT_ICONS[account.account_type]} UniversalSearch__userIcon`} size={"large"} />
                                                <ClippedContent>
                                                    <span>
                                                        {account.account_name}
                                                    </span>
                                                </ClippedContent>
                                            </div>
                                        )}
                                    </Grid.Column>
                                </Grid.Row>
                            )
                        })}
                    </Grid>
            ) : (
                loading ? (
                    <Segment basic loading />
                ) : (
                    <EmptyListPlaceholder
                        title={"No results found"}
                        subtitle={' '}
                    />
                )
            )}
            </Segment>
        </div>
)

const TopNavigation = ({ isSidebarOpen, onToggleMainMenu, phone, isOutsideRunningDialer, dialerContactID }) => {
    const LIMIT =  7;

    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    
    const { name, email, profilePicture, user_id, isReadingUser, centerNotifications, isReadingNotificationCenter, hasNotifications, userPermissions, paused } = useSelector((state) => {  
        return {
            name: state.auth.name,
            email: state.users.userProfile.email,
            profilePicture: state.user.logged_in_user_image || '',
            user_id: state.auth.user_id,
            isReadingUser: state.auth.isAuthenticatingUser || state.users.isReadingUser,
            centerNotifications: state.notifications.centerNotifications,
            isReadingNotificationCenter: state.notifications.isReadingNotificationCenter,
            hasNotifications: state.notifications.hasNotifications,
            userPermissions: state.role.userPermissions.permission,
            paused: state.auth.paused,
        }
    });
    const { isUniversalSearchLoading, universal_search_data } = useSelector((state)=>state.contact)
    const [isModulesModalOpen, setIsModulesModalOpen] = useState(false);
    const [isNotficationsOpen, setIsNotficationsOpen] = useState(false);
    const [isSearchFocused,setIsSearchFocused] = useState(false)
    const settingsViewPermissionPaths = Object.values(SETTINGS_PERMISSION_MAP || {})?.flat()
    const isSettingsOff = multipleRestriction(settingsViewPermissionPaths, userPermissions);
    const isRecordsOff = multipleRestriction([USER_PERMISSIONS.CONTACTS_ADD, USER_PERMISSIONS.LEAD_ADD, USER_PERMISSIONS.OPPORTUNITY_ADD, USER_PERMISSIONS.ACCOUNT_ADD, USER_PERMISSIONS.MASTER_ACCOUNT_ADD, USER_PERMISSIONS.OPPORTUNITY_ADD, USER_PERMISSIONS.LEAD_ADD], userPermissions);

    const showModal = () => {
        setIsModulesModalOpen(true);
    }
    
    const closeModal = () => {
        setIsModulesModalOpen(false);
    }

    const onRecordCurrentRoute = () => {
        dispatch(
            appActions.onSaveSettingsRoute(
                `${location.pathname}${location.search}`
            )
        );
    };
    
    const onToggleNotfications = () => {
        setIsNotficationsOpen(prevState => (!prevState));
    } 
    
    const onLogOut = () => {
        dispatch(authActions.logout()).then(() => {
            if (window.location.hostname.includes("sales")) {
                window.location.href = `${basePath.USER_HOST}/login`;
            }
        });
        dispatch(role.resetRole("RESET_ROLE"));
        dispatch(subscription.resetProduct("RESET_PRODUCT"));
        if(phone?.current){
            phone.current?.phone?.disconnect();
            phone.current = {}
        }
    }   

    const {
        onToggleModal,
        taskModalOpen,
        setTaskModalOpen,
        control,
        watch,
        isValid,
        isDirty,
        trigger,
        setValue,
        getValues,
        reset,
        isAllowedToModify,
        eventBeingEdited,
        handleSubmitEvent,
        resetField,
        taskControl,
        taskWatch,
        taskIsValid,
        taskIsDirty,
        taskTrigger,
        taskSetValue,
        taskGetValues,
        taskClearErrors,
        taskSetError,
        taskReset,
        taskBeingEdited,
        loadTask,
        addTask,
        state,
        setState,
        onDeleteTask,
        onUpdateTask,
        handleSubmit,
        task_labels,
        organizer_id,
        organizer,
        organizer_email,
        eventModalOpen,
        emailModalOpen,
        emailData,
        person_id,
        onDelete,
        onUpdate,
        onClearAllNotifications,
        onClearNotification,
        setEventModalOpen,
        onOpenNotification,
        current_user,
        setNotificationContactName
    } = NotificationPopupModals();

    useEffect(() => {
        dispatch(textActions.getPhones());
        dispatch(textActions.getUnsubscribed());
    }, [dispatch])

    useEffect(() => {
        dispatch(userActions.readLoggedInUserProfileLogo({ thumbnail: true, user_id }))
    }, [dispatch, user_id]);

    useEffect(() => {
        if(centerNotifications.length === 0){
            dispatch(notificationsActions.hasReadNotifications());
        }
    }, [dispatch, centerNotifications]);

    const readNotificationCenter = useCallback(() => {
        return dispatch(notificationsActions.onReadNotificationCenter());
    }, [dispatch]);

    useEffect(() => {
        dispatch(contactActions.getRecordsLimits());
    }, [dispatch]);

    const isNotificationsButtonsDisabled = (isReadingNotificationCenter || centerNotifications.length === 0);
    const [isFormDirty, setIsFormDirty] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [activeContent, setActiveContent] = useState('selection');
    const onClose = () => {
        setActiveContent('selection');
        closeModal();
    }
    const [searchState, setSearchState] = useState({
            universal_search_options: [],
            count: 0,
            page: 1,
            search: '',
            open: false,
        });
    
    const searchFunction = async (search) => {
        const { data, count } = await dispatch(contactActions.universalSearch({ page: 1, search: search, limit: LIMIT }));
        setSearchState({ ...searchState, universal_search_options: data || [], count: count || 0, open: true, page: searchState.page, search: search });
    }

    const cancelFunction = async () => {
        setSearchState({ ...searchState, universal_search_options: [], count: 0, open: false, page: 1, search: '' });
    }

    const onChangeSearch = (_, { value }) => {
        setSearchState({ ...searchState, universal_search_options: [], count:0, page:1, search: value, open: false });
    }

    useEffect(()=>{
        if(isSearchFocused && searchState.universal_search_options?.length > 0){
            setSearchState({ ...searchState, open: true });
        }else{
            setSearchState({ ...searchState, open: false });
        }
        // eslint-disable-next-line
    }, [isSearchFocused])

    const { onCloseSidePanel } = useContext(MainSidePanelContext);
    const handleCallModeToggle = async () => {
        try {
            await dispatch(usersActions.updateLeadConnectStatus("", { paused: !paused },{user_id: user_id}));
            Notification.alert('Successfully updated call mode', STATUS_TYPES.SUCCESS, true);
        } catch (error) {
            Notification.alert('Failed to update call mode', STATUS_TYPES.ERROR, true);
        }
    }

    return (
        <React.Fragment>
            <Menu className={`DYL2MenuTop ${isSidebarOpen ? 'DYL2MenuTop--squished' : 'DYL2MenuTop--full'}`} fixed={"top"} secondary>
                <Menu.Item>
                    <Popup
                        trigger={
                            <Icon
                                circular
                                className='MenuTop__Chevron'
                                name={
                                    isSidebarOpen
                                        ? "chevron left"
                                        : "chevron right"
                                }
                                link
                                onClick={onToggleMainMenu}
                            />
                        }
                        content={
                            isSidebarOpen
                                ? "Close menu"
                                : "Open menu"
                        }
                        position="right center"
                        inverted
                    />
                </Menu.Item>
                    <RestrictView type="link" error403={<Error403 />} isRestricted={isRecordsOff}>
                        <Menu.Item>
                                <Popup
                                    trigger={
                                        <Icon
                                            inverted
                                            className="fas fa-plus-circle"
                                            link
                                            onClick={showModal}
                                            size='big'
                                        />
                                    }
                                    content={"Add New"}
                                    position="right center"
                                    inverted
                                />
                        </Menu.Item>
                    </RestrictView>
                <Menu.Menu
                    className={`DYL2MenuTopRight--${isSidebarOpen ? "squished" : "full"
                        }`}
                    position="right"
                >
                    {isOutsideRunningDialer && (
                        <Menu.Item>
                            <SemanticButton className="BackToDialerButton" onClick={() => {
                                onCloseSidePanel();
                                dispatch(contactsActions.dialerViewLookup(dialerContactID))
                            }} as={Link} to={`/contact/${dialerContactID}`}><Icon className="fas fa-megaphone" />Back to Dialer</SemanticButton>
                        </Menu.Item>
                    )}                    
                    <Menu.Item className="DYL2MenuItemTopRight">
                        {!isReadingUser &&
                            <span className="DYL2MenuItemTopRight--name">
                                <Popup
                                    trigger={<div className={`TopNavigation__CallMode TopNavigation__CallMode${paused? "--red" : "--green"}`} onClick={handleCallModeToggle} />
                                    }
                                    content={paused ? "Call Mode: Off" : "Call Mode: On"}
                                    position="bottom right"
                                    inverted
                                />
                                Hello, {name}! &nbsp; <TZDisplay />
                            </span>
                        }
                    </Menu.Item>
                    <Menu.Item className={`UniversalSearch${isSearchFocused ? '--focused' : ''}`}>
                        <SearchableOptions
                            loading={isUniversalSearchLoading}
                            search={searchState.search}
                            validationPattern={VALIDATION_PATTERNS.alphanumeric_w_special_chars_for_universal_search}
                            searchFunction={searchFunction}
                            cancelSearchFunction={cancelFunction}
                            searchPlaceholder={'Search by Name, Phone, or Email'}
                            onChangeSearch={onChangeSearch}
                            isSearchResultsVisible={searchState.open || (isSearchFocused && searchState.universal_search_options?.length > 0)}
                            renderSearchResults={<UniversalSearchResults
                                universal_search_data={universal_search_data}
                                universal_search_options={searchState.universal_search_options}
                                loading={isUniversalSearchLoading}
                                onSelectContact={(id, contact_type) => { 
                                    const targetUrl = contact_type === "person" ? `/contact/${id}` : `/account/${id}`;
                                    if (location.pathname === targetUrl) {
                                        navigate(0);
                                      } else {
                                        navigate(targetUrl);
                                      }
                                }}
                                search={searchState.search}
                                checkIfContactCanBeSelected={false}
                            />}
                            isPaginationVisible={searchState.universal_search_options?.length > 0}
                            paginationProps={{
                                boundaryRange: 0,
                                activePage: searchState.page,
                                ellipsisItem: null,
                                siblingRange: 2,
                                totalPages: Math.ceil(searchState.count / LIMIT),
                                onPageChange: async (_, { activePage }) => {
                                    setSearchState({ ...state, loading: true, open: true, page: activePage, search: searchState.search });
                                    const { data, count } = await dispatch(contactActions.universalSearch({ page: activePage, search: searchState.search, limit: LIMIT }));
                                    setSearchState({ ...state, page: activePage, universal_search_options: data, count, loading: false, open: true, search: searchState.search });
                                }
                            }}
                            floatingResults
                            onFocus={() => {
                                setIsSearchFocused(true)
                            }}
                            onBlur={(_, { value }) => {
                                if(!searchState.open){
                                    setIsSearchFocused(false)
                                    if (value) {
                                        setSearchState({ ...searchState, search: value });
                                    }
                                }
                            }}
                            onClose={() => {
                                setIsSearchFocused(false)

                                setSearchState({ ...searchState, open: false });
                            }}
                            closeOnTriggerMouseLeave={false}
                            closeOnTriggerBlur={false}
                            closeOnTriggerClick={false}
                            stayFocused={true}
                        />
                    </Menu.Item>
                    <Menu.Item>
                        <OnHoverOnClick
                            inverted 
                            className="TopNavigation__Notifications"
                            pinned
                            position={isNotficationsOpen ? 'bottom center' : 'left center'}
                            trigger={
                                <>
                                    {hasNotifications &&
                                        <div className="TopNavigation__Notifications--Dot" />
                                    }
                                    <Icon name="bell" size="large" inverted style={{ cursor: 'pointer' }}/>
                                </>
                            }
                            hoverContent='Notifications'
                            invertedHover
                            basic={false}
                            clickContent={ 
                                <div style={{padding: 10, width: 450}}>
                                    <Grid>
                                        <Grid.Column width='4'><Header as='h3'>Notifications</Header></Grid.Column>
                                        <Grid.Column width='6' textAlign='right' style={{paddingLeft:0, paddingRight:0}}><Button basic as='a' href='/notifications'>View All</Button></Grid.Column>
                                        <Grid.Column width='4' textAlign='right' style={{paddingLeft:0, paddingRight:0}}><Button disabled={isNotificationsButtonsDisabled} as='on' onClick={(e)=> {e?.stopPropagation?.(); onClearAllNotifications();}}>Clear All</Button></Grid.Column>
                                        <Grid.Column verticalAlign='middle'><Icon className="fa-solid fa-xmark" size='large' onClick={()=> onToggleNotfications()} style={{ cursor: 'pointer' }}/></Grid.Column>
                                    </Grid>
                                    <Notifications
                                        notifications={centerNotifications} 
                                        onOpen={onOpenNotification}
                                        onClear={onClearNotification}
                                        loading={isReadingNotificationCenter}
                                    />
                                </div>
                            }
                            open={isNotficationsOpen}
                            onClick={
                                () => {
                                    dispatch(leftSidebar.onSetActiveSecondarySidebar(''))
                                    onToggleNotfications();
                                    readNotificationCenter();
                                }
                            }
                            onCloseOnDocumentClick={
                                () => {
                                    setIsNotficationsOpen(false)
                                }
                            }
                        />
                    </Menu.Item>
                    <Menu.Item>
                        <Dropdown
                            inline
                            text={
                                <Popup
                                    trigger={<Icon
                                        name="question circle"
                                        size="large"
                                        inverted
                                    />}
                                    inverted
                                    content='Support'
                                    position='left center'
                                />
                            }
                        >
                            <Dropdown.Menu>
                                {/* <Dropdown.Item
                                    content='Help'
                                    href='https://dyl-cloud.atlassian.net/servicedesk/customer/portals'
                                    target='_blank'
                                /> */}
                                <Dropdown.Item
                                    content='Support'
                                    href='https://dyl.com/support'
                                    target='_blank'
                                />
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Item>
                    <Menu.Item>
                        <Dropdown
                            inline
                            text={
                                <DYLAvatar name={name} email={email} picture={profilePicture} position='left center'/>
                            }
                        >
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    content="Profile"
                                    as={Link}
                                    to={`/settings/users/${user_id}/general`}
                                    onClick={onRecordCurrentRoute}
                                />
                                <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.BILLING_VIEW}>
                                <Dropdown.Item 
                                    content="Billing"
                                    onClick={onRecordCurrentRoute}
                                    as={Link}
                                    to={`/settings/billing/overview`}
                                />
                                </RestrictedView>
                                <Dropdown.Item
                                    content="Logout"
                                    onClick={onLogOut}
                                />
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Item>
                    <RestrictView type="link" error403={<Error403 />} isRestricted={isSettingsOff}>
                    <Menu.Item
                        icon={(
                            <Popup
                                trigger={<Icon
                                    name="cog"
                                    size="large"
                                    className="TopMenu--Gear"
                                    inverted

                                />}
                                inverted
                                content='Settings'
                                position='left center'
                            />
                        )}
                        as={Link}
                        to="/settings/general"
                        link
                        onClick={onRecordCurrentRoute}
                    />
                    </RestrictView>
                </Menu.Menu>
                
            </Menu>
            <SelectionsModal
                selectionHeader='Add New'
                categories={modalCategories}
                ToRender={AddModuleRecordsModalContent}
                toRenderProps={{ onDirtyChange: (dirty) => setIsFormDirty(dirty) }}
                contentModalSize={activeContent => {
                    if (activeContent === 'selection') {
                        return 'tiny'
                    }
                    if (activeContent === 'MasterAccount') {
                        return 'small';
                    }
                    return null;
                }}
                open={isModulesModalOpen}
                onClose={() => {
                    isFormDirty
                        ? setIsConfirmationOpen(true)
                        : onClose();
                }}
                activeContent={activeContent}
                setActiveContent={setActiveContent}
            />
            <SendEmailModal
                open={emailModalOpen}
                onClose={() => { if(emailModalOpen){onToggleModal("email", 0)} }}
                contact_id={person_id}
            />
            <AddTaskModal
                open={taskModalOpen}
                onClose={() => setTaskModalOpen(false)}
                state={state}
                control={taskControl}
                watch={taskWatch}
                isValid={taskIsValid}
                isDirty={taskIsDirty}
                trigger={taskTrigger}
                setValue={taskSetValue}
                getValues={taskGetValues}
                clearErrors={taskClearErrors}
                setError={taskSetError}
                reset={taskReset}
                taskBeingEdited={taskBeingEdited}
                loadTask={loadTask}
                addTask={addTask}
                setState={setState}
                onDelete={onDeleteTask}
                onUpdate={onUpdateTask}
                task_labels={task_labels}
                organizer_id={organizer_id}
                organizer={organizer}
                organizer_email={organizer_email}
                handleSubmit={handleSubmit}
                onRefresh={() => setTaskModalOpen(false)}
                email={emailData} 
            />
            <AddEventModal
                open={eventModalOpen}
                onClose={() => setEventModalOpen(false)}
                onEdit={handleSubmitEvent(onUpdate)}
                onDeleteEvent={onDelete}
                eventBeingEdited={eventBeingEdited}
                selected_users={[current_user]}
                isAllowedToModify={isAllowedToModify}
                control={control}
                watch={watch}
                isValid={isValid}
                isDirty={isDirty}
                trigger={trigger}
                setValue={setValue}
                getValues={getValues}
                reset={reset}
                resetField={resetField}
                setNotificationContactName={setNotificationContactName}
                displayAllContacts
            />
             <FullScreenModalPopUp
                header={"Changes not saved"}
                subheader={"Are you sure you want to exit?"}
                isOpen={isConfirmationOpen}
                onConfirm={() => {
                    onClose()
                    setIsConfirmationOpen(false);
                    setIsFormDirty(false)
                }}
                onFormClose={() => setIsConfirmationOpen(false)}
                closeIcon={false}
            />
        </React.Fragment>
    );
};

export default (withRouter(TopNavigation));

